import { render } from "./MainView.vue?vue&type=template&id=01b26eef&scoped=true&ts=true"
import script from "./MainView.vue?vue&type=script&lang=ts"
export * from "./MainView.vue?vue&type=script&lang=ts"

import "./MainView.vue?vue&type=style&index=0&id=01b26eef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b26eef"]])

export default __exports__